import InputAdornment from '@material-ui/core/InputAdornment';
import TextField, {TextFieldProps} from '@material-ui/core/TextField';
import Popover from '@material-ui/core/Popover';
import {makeStyles, withStyles} from '@material-ui/core/styles';

export type StyledTextFieldProps = Partial<
    Omit<TextFieldProps, 'onBlur' | 'onChange' | 'onClick' | 'ref' | 'value' | 'focused' | 'select'>
>;

export const StyledTextField = withStyles(theme => ({
    root: {
        width: '100%',

        '& input': {
            cursor: 'pointer',
            width: '100%'
        },

        '& [class*="formControl"]': {
            cursor: 'pointer'
        },

        [theme.breakpoints.up('md')]: {
            width: 'inherit'
        }
    }
}))(TextField);

export const StyledInputAdornment = withStyles(theme => ({
    root: {
        lineHeight: 0
    }
}))(InputAdornment);

export const StyledPopover = withStyles(theme => ({
    paper: {
        marginTop: theme.spacing(1),
        //@ts-ignore
        backgroundColor: theme.palette.background.overlays,
        width: 'inherit'
    }
}))(Popover);

const useStyles = makeStyles(theme => ({
    menuList: {
        overflow: 'hidden',
        overflowY: 'auto',
        maxHeight: theme.spacing(50)
    },
    menuListItem: {
        textOverflow: 'ellipsis',
        overflow: 'hidden',
        display: 'block',
        whiteSpace: 'nowrap',
        '&:first-child': {
            marginTop: theme.spacing(1)
        },
        '&:last-child': {
            marginBottom: theme.spacing(1)
        }
    }
}));

export default useStyles;
